<template>
  <div
    :class="dateButtonClass"
    class="daterangepicker-btn"
  >
    <i class="fa fa-calendar" />
    <span ref="dateText" />
    <strong class="caret" />
  </div>
</template>

<script>
import 'bootstrap-daterangepicker/daterangepicker';
import $ from 'jquery';
import moment from 'moment';
import { isMoment } from 'moment';

import {formatTimeInTimeZone} from '@/data/getDateRanges';

const defaultOptions = {
  buttonClasses: 'btn btn-sm',
  applyClass: 'btn-primary',
  cancelClass: 'btn-danger m-l-10'
};

export default {
  name: 'DateRangePickerSingle',
  props: {
    dateButtonClass: {
      type: String,
      default: ''
    },
    selectedDate: {
      type: Object,
      validator(value) {
        if (value && !isMoment(value)) return false;
        return true;
      },
      default() {
        return moment().tz(this.timeZoneId);
      }
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    format: {
      type: String,
      default: 'MMM D, YYYY'
    },
    timeZoneId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pickerElement: null
    };
  },
  computed: {
    startDate() {
      return this.selectedDate || moment().tz(this.timeZoneId);
    },
    endDate() {
      return this.selectedDate || moment().tz(this.timeZoneId);
    },
    customOptions() {
      return {
        locale: {
          format: this.format
        },
        startDate: this.startDate,
        endDate: this.endDate,
        ...defaultOptions,
        ...this.options
      };
    },
    date: {
      get() {
        return this.selectedDate;
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.$emit('change', newValue);
        this.$emit('onDateChange', newValue);
        this.setNewDateOnUI(newValue);
      }
    }
  },
  watch: {
    selectedDate(newValue) {
      this.setNewDateOnUI(newValue);
      this.$emit('onDateChange', newValue);
    },
    options(newValue) {
      this.initializeDateRangePicker({
        ...this.customOptions,
        ...newValue
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeDateRangePicker({
        ...this.customOptions
      });

      this.setNewDateOnUI(this.selectedDate);
    });
  },
  beforeDestroy() {
    $(this.$el)
      .daterangepicker('hide')
      .daterangepicker('destroy');
  },
  methods: {
    setNewDateOnUI(newDate) {
      if (!newDate || !this.pickerElement) {
        return;
      }

      const el = this.pickerElement.data('daterangepicker');

      if (el) {
        el.setStartDate(newDate);
        el.setEndDate(newDate);
      }

      this.$refs['dateText'].textContent = `${formatTimeInTimeZone(newDate, this.timeZoneId, this.format)}`;
    },

    initializeDateRangePicker(options) {
      this.pickerElement = $(this.$el);
      this.pickerElement.daterangepicker(options);

      this.pickerElement.on('apply.daterangepicker', (event, picker) => {
        this.date = picker.startDate;
      });
    }
  }
};
</script>